export const getScheduleEndpoint = ({ therapistId }: { therapistId: string }) =>
  `therapists/${therapistId}/schedule`;
